import {SingletonService} from '@/common/dependency.configs'
import {injectable} from 'inversify'

@SingletonService
@injectable()
class WindowFacade {

  constructor() {}

  getLocation(): Location {
    return window.location
  }

}

export default WindowFacade;
